import { Button } from '@onyx/ui/components/colleague/button';
import { IconButton } from '@onyx/ui/components/colleague/icon-button';
import { getClassName } from '@onyx/ui/style-utils';

import styles from './snack-bar.module.css';
type SnackbarVariant = 'inline' | 'stacked';

export type SnackbarProps = {
  text: string;
  variant?: SnackbarVariant;
  buttonText?: string;
  onButtonPress?: () => void;
  onClose?: () => void;
  className?: string;
};

export const Snackbar = ({
  text,
  variant = 'inline',
  buttonText,
  onButtonPress,
  onClose,
}: SnackbarProps) => {
  const variantMap: Record<SnackbarVariant, string> = {
    inline: styles.variantInline,
    stacked: styles.variantStacked,
  };

  const classNames = getClassName([styles.snackbar, variantMap[variant]]);

  const Actions = () => (
    <div className={styles.actions}>
      {!!buttonText && (
        <Button isInverse variant="text" onClick={onButtonPress}>
          {buttonText}
        </Button>
      )}
      <IconButton
        isInverse
        onClick={onClose}
        icon="Close"
        aria-label="Dismiss notification"
      />
    </div>
  );

  return (
    <div className={classNames}>
      <div className={styles.content}>
        <div className={styles.text}>{text}</div>
        <Actions />
      </div>
    </div>
  );
};
